var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPlus = function SvgPlus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 15.565,
    fill: "#fff",
    stroke: "#008938",
    strokeWidth: 0.87
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.02 22.165v-5.454H9.973v-1.89h5.049V9.367h1.97v5.454h5.05v1.89h-5.05v5.454h-1.97Z",
    fill: "#008938"
  })));
};
export default SvgPlus;